import React, { createContext, useContext, useState, useCallback } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("adg_lang") || "it");

  const changeLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem("adg_lang", l);
  }, []);

  // t("hero.title1") -> string; supports {n} interpolation via second arg
  const t = useCallback(
    (path, vars) => {
      const parts = path.split(".");
      let node = translations[lang];
      for (const p of parts) {
        node = node?.[p];
        if (node === undefined) break;
      }
      let str = node !== undefined ? node : path;
      if (typeof str === "string" && vars) {
        Object.entries(vars).forEach(([k, v]) => {
          str = str.replace(`{${k}}`, v);
        });
      }
      return str;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}